import { render, staticRenderFns } from "./CommunicationPanel2.vue?vue&type=template&id=4333da62&scoped=true&"
import script from "./CommunicationPanel2.vue?vue&type=script&lang=js&"
export * from "./CommunicationPanel2.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationPanel2.vue?vue&type=style&index=0&id=4333da62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4333da62",
  null
  
)

export default component.exports